import "../assets/css/Login.css";
import "../assets/css/ForgotPassword.css";

import { Link } from "react-router-dom";
import usePageTitle from "../hooks/usePageTitle";
import PageChrome from "../components/PageChrome";
import Footer from "../components/Footer";
import CopyRight from "../components/CopyRight";
import {
  FORGOT_PASSWORD_ADMIN,
  FORGOT_PASSWORD_MESSAGES,
} from "../utils/forgotPassword";

const ForgotPassword = () => {
  usePageTitle("Forgot Password", {
    description:
      "Contact Dewangan Links admin to reset your matrimony account password.",
  });

  const t = FORGOT_PASSWORD_MESSAGES.en;
  const { phoneDisplay, phoneTel, email, whatsappUrl, location } =
    FORGOT_PASSWORD_ADMIN;

  return (
    <div className="dw-login-page dw-forgot-page">
      <PageChrome />

      <section>
        <div className="login">
          <div className="container">
            <div className="row">
              <div className="inn dw-forgot-inn">
                <div
                  className="rhs"
                  style={{
                    gridColumn: "1 / -1",
                    maxWidth: 520,
                    margin: "0 auto",
                  }}
                >
                  <div className="form-tit">
                    <h1>{t.title}</h1>
                    <p>{t.lead}</p>
                  </div>

                  <ul className="dw-forgot-modal__contacts dw-forgot-page__contacts">
                    <li>
                      <a href={`tel:${phoneTel}`}>
                        <i className="fa fa-phone" aria-hidden="true" />
                        <span>
                          <strong>{t.call}</strong>
                          {phoneDisplay}
                        </span>
                      </a>
                    </li>
                    <li>
                      <a href={`mailto:${email}`}>
                        <i className="fa fa-envelope-o" aria-hidden="true" />
                        <span>
                          <strong>{t.email}</strong>
                          {email}
                        </span>
                      </a>
                    </li>
                    <li>
                      <a
                        href={whatsappUrl}
                        target="_blank"
                        rel="noopener noreferrer"
                      >
                        <i className="fa fa-whatsapp" aria-hidden="true" />
                        <span>
                          <strong>{t.whatsapp}</strong>
                          {phoneDisplay}
                        </span>
                      </a>
                    </li>
                  </ul>

                  <p className="dw-forgot-modal__location">
                    <i className="fa fa-map-marker" aria-hidden="true" />{" "}
                    {location}
                  </p>

                  <Link to="/login" className="btn btn-primary">
                    {t.backLogin}
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      <Footer />
      <CopyRight />
    </div>
  );
};

export default ForgotPassword;
